export default "__VITE_ASSET__BWTXJBxo__"